const PropTypes = require('prop-types');
const React = require('react');
const ZopimStore = require('components/zopim/zopim_store.js');
const moment = require('moment');

class HelpDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      chatOnline: false,
      currentTime: moment(),
    };

    this.handleOnlineStatusUpdated = this.handleOnlineStatusUpdated.bind(this);
    this.handleOpenChatWidget = this.handleOpenChatWidget.bind(this);
    this.updateCurrentTime = this.updateCurrentTime.bind(this);
  }

  componentDidMount() {
    ZopimStore.listen(this.handleOnlineStatusUpdated);
    window.setInterval(this.updateCurrentTime, 1000 * 60); // every 1 minute
  }

  componentWillUnmount() {
    ZopimStore.unlisten(this.handleOnlineStatusUpdated);
    window.clearInterval(this.updateCurrentTime);
  }

  handleOnlineStatusUpdated() {
    this.setState({
      chatOnline: ZopimStore.getState().chatOnline,
    });
  }

  handleOpenChatWidget(e) {
    e.preventDefault();
    window.$zopim.livechat.window.show();
  }

  updateCurrentTime() {
    this.setState({ currentTime: moment() });
  }

  renderStartChat() {
    if (this.state.chatOnline) {
      return (
        <li>
          <a
            className="site-header__menu__link site-header__menu__link--chat"
            onClick={this.handleOpenChatWidget}
          >
            {I18n.t('js.helpDropdown.chatLive')}
          </a>
        </li>
      );
    }
    return null;
  }

  renderChatHours() {
    if (this.props.isUSDepartment) {
      return (
        I18n.t('js.helpDropdown.chatHoursCentralTime')
      );
    }
    return (
      I18n.t('js.helpDropdown.chatHoursCentralEuropeanTime')
    );
  }

  render() {
    return (
      <div>
        <ul>
          <li>
            <a
              href={this.props.helpUrl}
              className="site-header__menu__link"
            >
              {I18n.t('js.helpDropdown.faqs')}
            </a>
          </li>
          <li>
            <a
              className="site-header__menu__link"
              href={this.props.dashboardBuyingOrdersPath}
            >
              {I18n.t('js.helpDropdown.trackOrder')}
            </a>
          </li>
          <li>
            <a
              href={this.props.reverbProtectionUrl}
              className="site-header__menu__link"
            >
              {I18n.t('js.helpDropdown.reverbProtection')}
            </a>
          </li>
          <li>
            <a
              href={this.props.submitHelpRequestUrl}
              className="site-header__menu__link"
            >
              {I18n.t('js.helpDropdown.submitHelpRequest')}
            </a>
          </li>
          {this.renderStartChat()}
        </ul>
      </div>
    );
  }
}

HelpDropdown.propTypes = {
  submitHelpRequestUrl: PropTypes.string,
  helpUrl: PropTypes.string,
  dashboardBuyingOrdersPath: PropTypes.string,
  reverbProtectionUrl: PropTypes.string,
  isUSDepartment: PropTypes.bool,
};

module.exports = HelpDropdown;



// WEBPACK FOOTER //
// ./javascripts/components/header/help_dropdown.jsx